module.exports = __webpack_public_path__ + "static/media/Event4.ed9eadaa.jpg";